import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import logo from './vdoo.png';
import './App.css';
import LoginButton from './auth/login';
import { useAuth0 } from "@auth0/auth0-react";
import Dashboard from './dashboard/Dashboard';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import StarBackground from './common/StarBackground';

const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_URL || 'http://localhost:4000/',
  cache: new InMemoryCache()
});

function App() {
  const { user, isAuthenticated, isLoading } = useAuth0();
  if (isLoading) {
    return (
      <div className="App">
        <header className="App-header">
          <h3>Loading ...</h3>
        </header>
      </div>
    );
  }

  return (
    <BrowserRouter>
      {isAuthenticated ? (
        <ApolloProvider client={client}>
          <Routes>
            <Route 
              path="/dashboard/*" 
              element={<Dashboard {...user} />} 
            />
            <Route 
              path="/toduns/*" 
              element={<Dashboard {...user} />} 
            />
            <Route
              path="/contact/*"
              element={<Dashboard {...user} />}
            />
            <Route
              path="/calendar/*"
              element={<Dashboard {...user} />}
            />
            <Route
              path="*"
              element={<Navigate to="/dashboard" replace />}
            />
          </Routes>
        </ApolloProvider>
      ) : (
        <Routes>
          <Route
            path="/"
            element={
              <div className="App">
                <header className="App-header">
                  <StarBackground />
                  <img src={logo} className="App-logo" alt="logo" />
                  <p><LoginButton /></p>
                </header>
              </div>
            }
          />
          <Route
            path="*"
            element={<Navigate to="/" replace />}
          />
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default App;